import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const MultiSelect = ({ options, selectedValues, handleChange, placeholderText }) => {
  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      defaultValue={selectedValues}
      isMulti
      options={options}
      onChange={handleChange}
      placeholder={placeholderText}
    />
  );
};

MultiSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

MultiSelect.defaultProps = {
  options: [],
  selectedValues: []
};

export default MultiSelect;
